// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountDown_main__4rPJL {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: var(--color-primary-3);
  padding: 2rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 25em) {
  .CountDown_main__4rPJL {
    padding: 2rem 1rem;
    flex-direction: column;
    align-items: center;
  }
}
.CountDown_main__red__Z-hRZ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  padding: 2rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 25em) {
  .CountDown_main__red__Z-hRZ {
    padding: 2rem 1rem;
    flex-direction: column;
    align-items: center;
  }
}

.CountDown_banner__CNbUR {
  position: fixed;
  bottom: 2rem;
  width: 17vw;
  box-sizing: border-box;
  border-radius: 1rem;
  padding: 1rem;
  background-color: var(--color-white);
}
@media only screen and (max-width: 62.5em) {
  .CountDown_banner__CNbUR {
    width: 36.8vw;
    padding: 1.5rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .CountDown_banner__CNbUR {
    width: 52vw;
  }
}
@media only screen and (max-width: 62.5em) {
  .CountDown_banner__beside__C-tYo {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
}
@media only screen and (max-width: 56.25em) {
  .CountDown_banner__beside__C-tYo {
    grid-template-columns: 1fr;
  }
}
.CountDown_banner__icon__XgfjK {
  height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/CountDown/CountDown.module.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAGI;EAVJ;IAWQ,kBAAA;IACA,sBAAA;IACA,mBAAA;EAAN;AACF;AAEI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAEQ;EAXJ;IAYQ,kBAAA;IACA,sBAAA;IACA,mBAAA;EACV;AACF;;AAGA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oCAAA;AAAJ;AAEI;EATJ;IAUQ,aAAA;IACA,eAAA;EACN;AACF;AACI;EAdJ;IAeQ,WAAA;EAEN;AACF;AACQ;EADJ;IAEQ,aAAA;IACA,8BAAA;IACA,SAAA;EAEV;AACF;AAAQ;EAPJ;IAQQ,0BAAA;EAGV;AACF;AAAI;EACI,cAAA;AAER","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    background-color: var(--color-primary-3);\n    padding: 2rem;\n    margin-bottom: 2rem;\n\n    @media only screen and (max-width: $bp-400) {\n        padding: 2rem 1rem;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    &__red {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 1rem;\n        background-color: var(--color-error);\n        color: var(--color-white);\n        padding: 2rem;\n        margin-bottom: 2rem;\n\n        @media only screen and (max-width: $bp-400) {\n            padding: 2rem 1rem;\n            flex-direction: column;\n            align-items: center;\n        }\n    }\n}\n\n.banner {\n    position: fixed;\n    bottom: 2rem;\n    width: 17vw;\n    box-sizing: border-box;\n    border-radius: 1rem;\n    padding: 1rem;\n    background-color: var(--color-white);\n\n    @media only screen and (max-width: $bp-1000) {\n        width: 36.8vw;\n        padding: 1.5rem;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        width: 52vw;\n    }\n\n    &__beside {\n        @media only screen and (max-width: $bp-1000) {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 1rem;\n        }\n\n        @media only screen and (max-width: $bp-900) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &__icon {\n        height: 1.7rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CountDown_main__4rPJL`,
	"main__red": `CountDown_main__red__Z-hRZ`,
	"banner": `CountDown_banner__CNbUR`,
	"banner__beside": `CountDown_banner__beside__C-tYo`,
	"banner__icon": `CountDown_banner__icon__XgfjK`
};
export default ___CSS_LOADER_EXPORT___;
